export const colorArr = [
  'Red',
  'Yellow',
  'Green',
  'Orange',
  'Pink',
  'Blue',
  'Purple',
  'Cyan',
  'Lime',
  'Geekblue',
  'Magenta',
  'Volcano',
]
